<script lang="ts">
  // One row of the Settings page: the setting's name, a line on what it
  // does, its control, and under them whatever is to be said of its state.
  // The control is named by the row's name and described by its line
  // (`labelId`, `descId`).
  import type { Snippet } from 'svelte';

  interface Props {
    /** Distinguishes the row's IDs on the page. */
    id: string;
    name: string;
    description: Snippet;
    control: Snippet<[{ labelId: string; descId: string }]>;
    /** What is to be said of the setting's state (a failed save, a warning). */
    notes?: Snippet;
  }
  let { id, name, description, control, notes }: Props = $props();
  const labelId = $derived(`setting-${id}-name`);
  const descId = $derived(`setting-${id}-what`);
</script>

<div class="setting-row" data-setting={id}>
  <span class="name" id={labelId}>{name}</span>
  <div class="control">{@render control({ labelId, descId })}</div>
  <p class="what" id={descId}>{@render description()}</p>
  {#if notes}<div class="notes">{@render notes()}</div>{/if}
</div>
